import { CustomerPaymentMethodModel } from '../../../models/Profile/CustomerPaymentMethodModel';
import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Customer } from 'src/app/models/Customer';


@Component({
  selector: 'app-add-payment-info',
  templateUrl: './add-payment-info.component.html',
  styleUrls: ['./add-payment-info.component.css']
})
export class AddPaymentInfoComponent implements OnInit {

  faTimesCircle=faTimesCircle;
  loggedInCustomer:Customer;
  submitted: boolean = false;


  constructor(
    private dialogRef: MatDialogRef<AddPaymentInfoComponent>,
    private dialog: MatDialog,
    private authService:AuthService
    ) {

  }

  form = new FormGroup({
    customerName: new FormControl('', Validators.required),
    cardNo: new FormControl('', Validators.required ),
    securityCode: new FormControl(null, Validators.required),
    expiryDateMonth: new FormControl(null, Validators.required),
    expiryDateYear: new FormControl(null, Validators.required),
  });


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  ngOnInit() {
    this.authService.loggedInCustomer.subscribe(res =>{
      this.loggedInCustomer=res;
    })
  }

  onSubmit(){



    if (this.form.valid) {


    } else {
      this.validateAllFormFields(this.form);

    }


    let addReq:CustomerPaymentMethodModel={
      customerID:this.loggedInCustomer.customerID,
      number:this.form.value["cardNo"],
      name:this.form.value["customerName"],
      cvv:this.form.value["securityCode"],
      expiryMonth:this.form.value["expiryDateMonth"],
      expiryYear:this.form.value["expiryDateYear"],
    }

    this.authService.addCustomerPaymentMethods(addReq).subscribe(res=>{
    if(res!=null){
      this.dialogRef.close({success:true});
    }








    })
   // alert(JSON.stringify(this.form.value));
  }

  close(): void {
    this.dialogRef.close();
  }

}
